import React, { useState, useEffect } from 'react';
import 'tailwindcss/tailwind.css';
import { FaChevronDown, FaBars, FaSignOutAlt } from 'react-icons/fa';
//import pomeloLogo from "../images/logo-p2.png";
import sclogo from "../images/logoSC.png";
import logoSC from "../images/logoAnimado.gif";
import { jwtDecode } from "jwt-decode";

const Navbar = () => {
  const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
  const [contentDropdownOpen, setContentDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    try {
      const token = localStorage.getItem("token");
      
      if (!token) {
        setIsAuthenticated(false);
        setIsAdmin(false);
        return;
      }
      
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      if (decodedToken.exp && decodedToken.exp < currentTime) {
        // Token expirado
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        setIsAdmin(false);
        return;
      }
      
      // Token válido
      setIsAuthenticated(true);
      
      // Verificar si es admin (ajusta según la estructura de tu token)
      setIsAdmin(decodedToken.rol === "Administrador" || decodedToken.isAdmin === true);
      
      // Guardar nombre de usuario si está disponible
      if (decodedToken.name || decodedToken.username) {
        setUserName(decodedToken.name || decodedToken.username);
      }
      
    } catch (error) {
      console.error("Error verificando autenticación:", error.message);
      setIsAuthenticated(false);
      setIsAdmin(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    setIsAdmin(false);
    setUserName('');
    // Redirigir a la página de inicio
    window.location.href = "/";
  };

  const toggleAdminDropdown = () => {
    setAdminDropdownOpen(!adminDropdownOpen);
    if (contentDropdownOpen) setContentDropdownOpen(false);
  };

  const toggleContentDropdown = () => {
    setContentDropdownOpen(!contentDropdownOpen);
    if (adminDropdownOpen) setAdminDropdownOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="p-4 border-b border-zinc-700 relative z-50">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          {/*hacer que al presionar el logo redirija a "/"*/}
          <a href="/" className="flex items-center">
          <img src={logoSC} alt="Website Logo" className="mr-4" style={{ height: 40, width: 80 }} />
          </a>
          {isAuthenticated ? (
            
            <div className="hidden md:flex items-center">
              {/*}
              <a href="/home" className="mr-4 font-pomelo">Home</a>
              <div className="relative mr-4">
                <button
                  onClick={toggleContentDropdown}
                  className="flex items-center font-pomelo focus:outline-none"
                >
                  Contenidos <FaChevronDown className="ml-2" />
                </button>
                {contentDropdownOpen && (
                  <div className="absolute mt-2 w-48 bg-zinc-800 border border-zinc-700 rounded shadow-lg z-50">
                    <a href="/contenido/series" className="block px-4 py-2 text-white hover:bg-zinc-700">WebSeries</a>
                    <a href="/contenido/cortometrajes" className="block px-4 py-2 text-white hover:bg-zinc-700">Cortometraje</a>
                    <a href="/contenido/musica" className="block px-4 py-2 text-white hover:bg-zinc-700">Videos Musicales</a>
                  </div>
                )}
              </div>
              */}
              
              {isAdmin && (
                /*
                <div className="relative mr-4">
                  <button
                    onClick={toggleAdminDropdown}
                    className="flex items-center font-pomelo focus:outline-none"
                  >
                    Panel de Administración <FaChevronDown className="ml-2" />
                  </button>
                  {adminDropdownOpen && (
                    <div className="absolute mt-2 w-48 bg-zinc-800 border border-zinc-700 rounded shadow-lg z-50">
                      <a href="/admin/usuario" className="block px-4 py-2 text-white hover:bg-zinc-700">Usuarios</a>
                      <a href="/admin/genero" className="block px-4 py-2 text-white hover:bg-zinc-700">Género</a>
                      <a href="/admin/serie" className="block px-4 py-2 text-white hover:bg-zinc-700">Serie</a>
                      <a href="/admin/filme" className="block px-4 py-2 text-white hover:bg-zinc-700">Filme</a>
                      <a href="/admin/capitulos" className="block px-4 py-2 text-white hover:bg-zinc-700">Capitulos</a>
                    </div>
                  )}
                </div>*/
                <a href="/" className="mr-4 font-pomelo">Inicio</a>
              )}
            </div>
          ) : (
            <a href="/" className="mr-4 font-pomelo">Inicio</a>
          )}
        </div>
        
        <div className="hidden md:flex items-center">
          {isAuthenticated ? (
            <>
              <a href="/Identity/Account/Manage" className="mr-4 font-pomelo">Perfil de usuario</a>
              <a href="/comentarios" className="mr-4 font-pomelo">Comentarios</a>
              <button 
                onClick={handleLogout} 
                className="flex items-center font-pomelo text-red-400 hover:text-red-300"
              >
                Cerrar sesión <FaSignOutAlt className="ml-2" />
              </button>
            </>
          ) : (
            <a href="/login" className="font-pomelo">Iniciar Sesión</a>
          )}
        </div>
        
        <button className="md:hidden" onClick={toggleMobileMenu}>
          <FaBars />
        </button>
      </div>
      
      {mobileMenuOpen && (
        <div className="md:hidden mt-4">
          {isAuthenticated ? (
            <>    
              {isAdmin && (
                /*
                <div className="py-2">
                  <button
                    onClick={toggleAdminDropdown}
                    className="w-full text-left font-pomelo focus:outline-none flex items-center justify-between"
                  >
                    Panel de Administración <FaChevronDown className={`transition-transform duration-200 ${adminDropdownOpen ? 'transform rotate-180' : ''}`} />
                  </button>
                  {adminDropdownOpen && (
                    <div className="pl-4 mt-2 space-y-2">
                      <a href="/admin/usuario" className="block py-1 font-pomelo">Usuarios</a>
                      <a href="/admin/genero" className="block py-1 font-pomelo">Género</a>
                      <a href="/admin/serie" className="block py-1 font-pomelo">Serie</a>
                      <a href="/admin/filme" className="block py-1 font-pomelo">Filme</a>
                      <a href="/admin/capitulos" className="block py-1 font-pomelo">Capitulos</a>
                    </div>
                  )}
                </div>*/
                <a href="/" className="mr-4 font-pomelo">Inicio</a>
              )}
              
              <a href="/Identity/Account/Manage" className="block py-2 font-pomelo">Perfil de usuario</a>
              <a href="/comentarios" className="block py-2 font-pomelo">Comentarios</a>
              <button 
                onClick={handleLogout} 
                className="w-full text-left py-2 font-pomelo text-red-400 flex items-center"
              >
                Cerrar sesión <FaSignOutAlt className="ml-2" />
              </button>
            </>
          ) : (
            <a href="/login" className="block py-2 font-pomelo">Iniciar Sesión</a>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;